import { configureStore, combineReducers } from "@reduxjs/toolkit";
import homeReducer from "./homeSlice";
import catalogReducer from "./catalogSlice";
import movieReducer from "./moviesSlice";
import detailReducer from "./detailSlice";
import searchReducer from "./searchSlice";
import filterReducer from "./filterSlice";

const rootReducer = combineReducers({
  home: homeReducer,
  catalog: catalogReducer,
  movies: movieReducer,
  detail: detailReducer,
  search:  searchReducer,
  filter:  filterReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
